import CompanyAdd from './CompanyAdd';

export default CompanyAdd;
